/**
 * This file contains the defaults meta tags injected when no other
 * availbale metas are present
 *
 */

export const defaultMetas = {
  fr: {
    title: "Vestiaire Collective : Dépot vente luxe, mode d'occasion",
    description:
      // tslint:disable-next-line: max-line-length
      "Leader mondial de la mode d'occasion, nous proposons un catalogue inspirant de plus 700.000 articles et plus 5.200 marques. ✅ Jusqu'à -70% du prix neuf !",
    keywords:
      // tslint:disable-next-line: max-line-length
      "Vestiaire Collective, marques de luxe, vêtements de créateurs d'occasion, mode, montres de luxe, sacs à main, chaussures en ligne, bijoux, vintage, femmes, hommes",
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Mode de Seconde Main 2020 !',
    searchDescription:
      "ll➤ Laissez-vous séduire par notre collection de searchValue, ainsi qu’un grand choix d'articles de luxe ! ✅ Jusqu'à -70% du prix du neuf ! ✅Paiement 3 fois ✅ Livraison rapide"
  },
  en: {
    title: 'Luxury resale store, find pre-owned fashion on Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'VestiaireCollective.com, the best of pre-owned fashion at 30 to 70% off original retail price. ✅ Buy! Sell! Share! ✅ 100% of the items are curated and manually controlled by our experts!',
    keywords:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, luxury brands, second hand designer clothes, fashion, luxury watches, handbags, shoes online, jewelry, vintage, women, men',
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Second Hand Fashion 2020!',
    searchDescription:
      'll➤ Let yourself be seduced by our collection of searchValue, as well as a large selection of luxury items! ✅ Up to -70% off of the retail price! ✅ 3 time payments ✅ Fast delivery'
  },
  it: {
    title: 'La migliore selezione di capi di moda sino a -70% del prezzo in negozio! - Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, il miglior marketplace di moda second-hand con prezzi fino al 70% in meno rispetto a quelli in boutique. ✅ Acquista, Vendi, Condividi! ✅ 100% degli articoli sono selezionati e controllati dai nostri esperti!',
    keywords:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, marchi di lusso, abiti firmati di seconda mano, moda, orologi di lusso, borse, scarpe online, gioielli, vintage, donne, uomini',
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Moda della Seconda mano 2020!',
    searchDescription:
      'll➤ Lasciati sedurre dalla nostra collezione di searchValue e da una vasta selezione di articoli di lusso! ✅ Fino al -70% del prezzo del nuovo! ✅ Pagamento in 3 volte ✅ Consegna rapida'
  },
  de: {
    title: 'Vestiaire Collective : Kaufen und verkaufen Sie Premium- und Luxusmode aus zweiter Hand',
    description:
      // tslint:disable-next-line: max-line-length
      'VestiaireCollective, die beste Secondhand- Mode für 30- bis 70% weniger als der originale Kaufpreis. ✅ Kaufen! Verkaufen! Teilen! ✅ 100% aller Artikel sind von unseren Experten kuratiert und manuell überprüft!',
    keywords:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, Luxusmarken, Second-Hand-Designer-Kleidung, Mode, Luxusuhren, Handtaschen, Schuhe online, Schmuck, Vintage, Frauen, Männer',
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Second Hand Mode 2020!',
    searchDescription:
      'll➤ Lassen Sie sich von unserer Kollektion searchValue sowie einer großen Auswahl an Luxusartikeln verführen! ✅ Bis zu -70% des Neupreises! ✅ Ratenzahlung möglich ✅ Schnelle Lieferung'
  },
  es: {
    title: 'Vestiaire Collective : El mejor sitio donde intercambiar ropa del mundo. Compra, vende y recicla',
    description:
      // tslint:disable-next-line: max-line-length
      'Vestiairecollective.com, ¡la plataforma de compraventa de lujo! ✅ ¡Compra, vende y vacía tu armario! ✅ ¡Encuentra el artículo de tus sueños! Nuestros equipos seleccionan y examinan todos nuestros artículos.',
    keywords:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, marcas de lujo, ropa de diseñador de segunda mano, moda, relojes de lujo, bolsos, zapatos en línea, joyas, vintage, mujeres, hombres',
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Moda de Segunda Mano 2020 !',
    searchDescription:
      'll➤ ¡Déjese seducir por nuestra colección de searchValue, así como por una gran selección de artículos de lujo! ✅ ¡Hasta -70% del precio nuevo! ✅ Pago en 3 veces ✅ Envío rápido'
  },
  us: {
    title: 'Luxury resale store, find pre-owned fashion on Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'VestiaireCollective.com, the best of pre-owned fashion at 30 to 70% off original retail price. ✅ Buy! Sell! Share! ✅ 100% of the items are curated and manually controlled by our experts!',
    keywords:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, luxury brands, second hand designer clothes, fashion, luxury watches, handbags, shoes online, jewelry, vintage, women, men',
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Second Hand Fashion 2020!',
    searchDescription:
      'll➤ Let yourself be seduced by our collection of searchValue, as well as a large selection of luxury items! ✅ Up to -70% off of the retail price! ✅ 3 time payments ✅ Fast delivery'
  }
};

export const journalMainPageMetas = {
  fr: {
    title: 'Journal : Tendances et guides de mode | Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      "ll➤ Découvrez le journal de Vestiaire Collective. ✔️ Reportages sur les dernières tendances, interviews de la communauté et anecdotes sur l'histoire de la mode."
  },
  en: {
    title: 'Journal : Fashion Trends & Guides | Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'll➤ Get into the Vestiaire Collective Journal. ✔️ Explore trend features, community interviews and fabulous stories from the world of fashion.'
  },
  it: {
    title: 'Journal: Guide su moda e trend | Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'll➤ Scopri il Journal di Vestiaire. ✔️ Trend, interviste con la community e incredibili aneddoti del mondo della moda in esclusiva per te.'
  },
  de: {
    title: 'Journal : Fashion Trends & Guides | Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'll➤ Entdecken Sie das Vestiaire Collective Journal. ✔️ Mit Trendfeatures, Community-Interviews und fabelhaften Geschichten aus der Modewelt.'
  },
  es: {
    title: 'Journal: Tu guía de moda y tendencias | Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'll➤ Descubre el Journal de Vestiaire Collective ✔️ Explora nuevas tendencias, entrevistas con la comunidad e increíbles historias del mundo de la moda.'
  },
  us: {
    title: 'Journal : Fashion Trends & Guides | Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'll➤ Get into the Vestiaire Collective Journal. ✔️ Explore trend features, community interviews and fabulous stories from the world of fashion.'
  }
};
